import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import {
  deleteMatSeccionesAction,
  setActivoMatSeccionesAction,
} from '../MatSeccionesAction';
import CardMatSeccionesComponent from './CardMatSecciones';

const ListadoMatSecciones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const matriculasStore = Redux.useSelector((state) => state.matriculas);
  const matSeccionesStore = Redux.useSelector((state) => state.matSecciones);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  const _handleEditClick = async (id) => {
    const data = matSeccionesStore.all.find((el) => el.id === id);
    await setActivoMatSeccionesAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteMatSeccionesAction(
      { dispatch, notify },
      matSeccionesStore.activo.id,
      {
        ...matSeccionesStore.params,
        idMatricula: matriculasStore.activo.id,
      },
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={matSeccionesStore.loadingAll || loadingDelete}
        />
      </Grid>
      {matSeccionesStore.all.map((el) => (
        <Grid item sx={12} md={6}>
          <CardMatSeccionesComponent
            key={el.id}
            data={el}
            onEdit={() => _handleEditClick(el.id)}
            onDelete={async () => {
              await setActivoMatSeccionesAction(dispatch, el);
              setOpenModalDelete(true);
            }}
          />
        </Grid>
      ))}
      {matSeccionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            Sección: {matSeccionesStore.activo.seccion.nombre}
          </Typography>
          <Typography variant="h6">
            Nivel académico:{' '}
            {
              matSeccionesStore.activo.seccion.nivelAcademico.nivelAcademico
                .nombre
            }
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoMatSecciones;
